<template>
  <VCol cols="auto" class="legal-links-col">
    <!-- One flex-wrap container, links as direct siblings and no pipe separators (FR-007).
         Gaps and wrapping come from FooterLegal's scoped style. Kept inside the
         root: beside it, the comment made the root a fragment in dev, which cannot
         inherit FooterLegal's data-testid. -->
    <div class="footer-legal-links">
      <FooterButton legal-link to="/legal/terms-of-use" data-testid="terms">
        {{ $t('footer.link.terms') }}
      </FooterButton>
      <FooterButton legal-link to="/legal/privacy-policy" data-testid="privacy-policy">
        {{ $t('footer.link.privacy') }}
      </FooterButton>
      <FooterButton
        legal-link
        :on-activate="showOsano"
        :aria-label="$t('footer.link.cookie')"
      >
        {{ $t('footer.link.cookie') }}
      </FooterButton>
    </div>
  </VCol>
</template>

<script lang="ts" setup>
import FooterButton from '~/components/layout/footer/FooterButton.vue'

// FooterLegal tags this block with its component name (data-testid).
defineOptions({ name: 'FooterLegalSp' })

const { showOsano } = useOsano()
</script>
